import TableColumn from "../../@biocrates-common-repo/core/models/tableColumn"
import TableRow from "../../@biocrates-common-repo/core/models/tableRow"

export default class DisplayDataTableData {
    metadataColumns?: TableColumn[]

    analyteColumns?: TableColumn[]

    headerRows?: TableRow[]

    rows: any[]

    demographics?: any

    constructor(
        metadataColumns: TableColumn[] = [],
        analyteColumns: TableColumn[] = [],
        headerRows: TableRow[] = [],
        rows: TableRow[] = []
    ) {
        this.metadataColumns = metadataColumns
        this.analyteColumns = analyteColumns
        this.headerRows = headerRows
        this.rows = rows
    }
}
